export default "__VITE_ASSET__D1DZM31S__"